import { render, staticRenderFns } from "./logsList.vue?vue&type=template&id=65403f26&scoped=true"
import script from "./logsList.vue?vue&type=script&lang=js"
export * from "./logsList.vue?vue&type=script&lang=js"
import style0 from "./logsList.vue?vue&type=style&index=0&id=65403f26&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65403f26",
  null
  
)

export default component.exports